import {
  withTranslation,
} from 'react-i18next';

import TrackerSectionView from './TrackerSectionView';
import './TrackerSection.css';

const TranslatedComponent = withTranslation()(TrackerSectionView);

const Component = TranslatedComponent;

export default Component;
